import React, { Component, Fragment } from 'react'
import delve from 'dlv'

export default class AuditWrapper extends Component {
  componentDidMount () {
    const { packageName = '', packageVersion = '' } = this.props
    const {
      zauditSlackDestination: slackChannel,
      auditMessageTemplate = '',
      auditName = packageName,
      auditVersion = packageVersion
    } = delve(window, 'clientOptions.module.options', {})
    const user = delve(window, 'clientOptions.user.email', 'anonymous user')
    const source = window.location.toString()

    const message = auditMessageTemplate
      .toString()
      .replace(/\{NAME\}/g, auditName)
      .replace(/\{VERSION\}/g, auditVersion)
      .replace(/\{USER\}/g, user)
      .trim()

    if (!message || !slackChannel) {
      return
    }

    window
      .fetch('/api/slack', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: window.JSON.stringify({
          message,
          msgOpt: {
            icon_emoji: ':ledger:',
            slackChannel,
            attachments: [
              {
                fallback: message,
                text: message,
                footer: source
              }
            ],
            overrideAttachments: true
          }
        })
      })
      .catch(() => {})
  }

  render () {
    return <Fragment>{this.props.children}</Fragment>
  }
}
